import React, { useState } from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import style from "../ViewLesson.module.css";
import styleActions from "./ActionsBottom.module.css";
import userStore from "../../../../base/stores/UserStore";
import deleteIcon from "../../../../base/assets/icons/delete-alt.svg";
import store from "../../lessonStore";
import { LessonDI } from "../../types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom"; import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";
import lessonStore from "../../lessonStore";
import AppStore from "../../../../base/stores/AppStore";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: "15px",
    overflowY: "inherit",
  },
}));
const ActionsBottom = ({ lesson }: { lesson: LessonDI }) => {
  const [t] = useTranslation();
  const user = userStore?.user;
  const isEditor = user?.isEditor || false;
   const navigate = useNavigate(); 

  const [confirmOpen, setConfirmOpen] = React.useState(false);

  const handleClose = () => {
    setConfirmOpen(false);
  };

  const handleAgree = () => {
    setConfirmOpen(false);
    deleteLesson();
  };

  const deleteLesson = async () => {
    try {
      if (lesson?.id) {
        await store.deleteLesson(lesson?.id, AppStore.isMobileResolution);
        lessonStore.setLessonJustDeleted(true);
        navigate(AppStore.lessonsRoute);
      }
      // do nothing if "id" is missing
    } catch (error: any) {
      alert(t("GeneralError"));
    }
  };

  if (!AppStore.isMobileResolution) return null; // only on mobile delete button should be visible

  if (!isEditor && lesson.isApproved) return null; // no actions should be rendered a at "approved" tab for "not editor"

  if (isEditor && lesson.isApproved)
    // delete button should be rendered at "approved" tab for "editor"
    return (
      <>
        <button
          className={styleActions.deleteButtonLink}
          onClick={() => setConfirmOpen(true)}
        >
          <img
            alt="delete button"
            src={deleteIcon}
            className={style.edit_icon}
          />
          {t("Lesson-delete")}
        </button>
        <BootstrapDialog
          open={confirmOpen}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{ "& .MuiPaper-root": { borderRadius: "22px" } }}

        >
          <div className={styleActions.bucketIcon} />
          <DialogTitle id="alert-dialog-title">
            <h2 className={styleActions.dialogTitle}>
              {t("Shall-Lesson-remove")}
            </h2>
          </DialogTitle>
          <DialogActions className={styleActions.dialogActions}>
            <Button
              className={styleActions.primary}
              onClick={handleAgree}
              autoFocus
            >
              {t("Lesson-delete-yes")}
            </Button>
            <Button onClick={handleClose} className={styleActions.secondary}>
              {t("Lesson-delete-no")}
            </Button>
          </DialogActions>
          <div className={styleActions.curve} />
        </BootstrapDialog>
      </>
    );

  return null;
};

export default observer(ActionsBottom);
